export const ButtonGroup = {
  MuiButtonGroupBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontFamily: 'Lato, sans-serif',
        fontSize: '16px',
        fontWeight: 600,
      },
    },
  },
};
